export default __webpack_public_path__ + "static/media/sticker-promo-co.c6f538f4.png";